// extracted by mini-css-extract-plugin
module.exports = {"lia-user-rank":"UserHoverCard_lia-user-rank__mmi6H","lia-user-badges-list":"UserHoverCard_lia-user-badges-list__1pTk7"};